export async function startRecordingOmni(
	_file?: unknown,
	_format?: 'seconds' | 'timecode',
	_deviceName?: string,
	_deviceId?: string,
	_onOmniEvent?: unknown,
	_onChildProcess?: unknown
): Promise<any> {
	return Promise.resolve(null);
}
export async function stopRecordingOmni(): Promise<any> {
	return Promise.resolve(null);
}
export async function checkPermissions(_openDialog: boolean): Promise<any> {
	return Promise.resolve(null);
}
export async function getAvailableDevicesMapOmni(_cacheDurationMs?: number): Promise<any> {
	return Promise.resolve(null);
}
export async function getOmniVersion(): Promise<any> {
	return Promise.resolve(null);
}
export async function killOngoingOmniProcesses(): Promise<any> {
	return Promise.resolve(null);
}
